import { SolarContract } from "@edp-models/edp-solar-contract.model";

interface ISolarStateKey {
    [key: string]: SolarContract[];
}

export interface ISolarState {
    solarContracts: ISolarStateKey;
}

export const initialSolarState: ISolarState = {
    solarContracts: null,
};
